import axios from 'axios'
import _ from 'lodash'

export default class {
  _presignUrl

  constructor() {
    this._presignUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_PRESIGN_OPERATION}`
  }

  postPresignUrl(files) {
    let documentos = []

    _.forEach(files, f => {
      const {
        nombre,
        tipo,
        tamanio,
        hash,
        descripcion,
        numeroPaginas,
        tipoDocumento,
        clave,
        folder,
        fechaExpiracion
      } = f
      documentos.push({
        nombre,
        tipo,
        tamanio,
        hash,
        descripcion,
        numeroPaginas,
        idTipoDocumento: tipoDocumento,
        clave,
        idCarpeta: folder.idCarpeta,
        fechaExpiracion
      })
    })
    return axios.post(this._presignUrl, { documento: documentos })
  }

  postUploadFile(file) {
    let formData = new FormData()

    Object.entries(file.presignUrl.fields).map(([key, value]) => {
      if(key != 'x-amz-meta-Status'){
        return formData.append(key, value)
      } 
    })

    formData.append('file', file.fileData)

    let instance = axios.create()
    delete instance.defaults.headers.common['Authorization']
    return instance.post(file.presignUrl.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
